import Modal from 'react-modal';
import {useState, useEffect} from 'react';
import { changeDisable, setMaskGeneric, viewItem, viewItemProduct, customShortModal, customFullModal, showMessageError, custom } from '../../../classes/functions';
import './requests.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import ModalConfirmation from '../../../components/Modal/ModalConfirmation/index.js';
import InputDate from '../../../components/Inputs/Date/index.js';

export default function ReturnRequest(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);
  
  const [listStatus, setListStatus] = useState([]);
  const [listStatusItem, setListStatusItem] = useState([]);
  const [listProducts, setListProducts] = useState([]);
  const [nome_cliente, setNomeCliente] = useState('');
  const [observacao, setObservacao] = useState('');
  const [status, setStatus] = useState('');
  const [data_solicitacao, setDataSolicitacao] = useState('');
  const [hora_solicitacao, setHoraSolicitacao] = useState('');
  const [integrated_erp, setIntegratedErp] = useState('');
  const [origin_request, setOriginRequest] = useState('');
  const [rows, setRows] = useState([]);
    
  const [item_nome_cliente, setItemNomeCliente] = useState('');
  const [item_observacao, setItemObservacao] = useState('');
  const [item_data_solicitacao, setItemDataSolicitacao] = useState('');
  const [item_hora_solicitacao, setItemHoraSolicitacao] = useState('');
  const [item_rows, setItemRows] = useState([]);
  const [item_feature, setItemFeature] = useState(false);
  const [modalOrigin, setModalOrigin] = useState(false);
  const [modalItemFeaturesOpen, setModalItemFeaturesOpen] = useState(false);
  const [infos, setInfos] = useState({
    data_solicitacao: "",
    item_data_solicitacao: ""
  });

  const [showModals, setShowModals] = useState({
    confirmDelete: false
  });

  useEffect(()=> {
    async function loadReturnRequest(){
      if (id) {
        getOne(id, option);
      }

      // getData();
    }
    loadReturnRequest();

  },[]);
  
  function closeModal() {
    setModalOrigin(false);
  }
  
  function closeModalFeatures() {
    setModalItemFeaturesOpen(false);
  }
  
  function getOne(id, option){
    api.get("/api/return_request/getList?id=" + id)
    .then((response) => {
        setNomeCliente(response.data.row.cliente.razao_social);
        setObservacao(response.data.row.observacao);
        setStatus(response.data.row.status);
        setInfos((prevState) => ({...prevState, data_solicitacao: response.data.row.data}));
        setHoraSolicitacao(response.data.row.hora);
        setIntegratedErp(response.data.row.integrated);
        setOriginRequest(response.data.row.id_request);
        
        setRows(response.data.rows);
    
        setCarrying(false);
      }
    ).catch((error) => {
      setCarrying(false);
      console.log(error);
      toast.error('Ops! Ocorreu um erro.');
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/return_request');
  }
  
  function remove(){
    api.delete("/api/return_request/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/return_request');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  async function getData() {
    api.get("/api/return_request/getDataPage")
    .then((response) => {
      setListStatus(response.data.status);
      setListStatusItem(response.data.status_item);
      setListProducts(response.data.products);
      
      setCarrying(false);
    }).catch((error) => {
      toast.error('Ops! Ocorreu um erro.');
      setCarrying(false);
    });
  }
  
  async function setIntegrateErp() {
    setCarrying(true);
    api.get("/api/return_request/setIntegratedErp?id=" + id)
    .then((response) => {
      getOne(id, option);
    }).catch((error) => {
      setCarrying(false);
      error.response.data.error.message.map((error) => {
        toast.error(error);
      });
    });
  }
  
  async function openViewOrigin() {
    api.get("/api/product_requests/getList?id=" + origin_request)
    .then((response) => {
        setItemNomeCliente(response.data.row.cliente.razao_social);
        setItemObservacao(response.data.row.observacao);
        setInfos((prevState) => ({...prevState, item_data_solicitacao: response.data.row.data}));
        setItemHoraSolicitacao(response.data.row.hora);
        
        setItemRows(response.data.rows);
    
        setModalOrigin(true);
      }
    ).catch((error) => {
      setCarrying(false);
      console.log(error);
      toast.error('Ops! Ocorreu um erro.');
    });
  }
  
  async function getDataFeatures(item, index) {
    setItemFeature(item.id_caracteristica_produto);
    setModalItemFeaturesOpen(true);
  } 
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />

      <ModalConfirmation state={showModals.confirmDelete} setState={setShowModals} stateName={'confirmDelete'} custom={custom('500px', '250px')} title={'Deseja realmente excluir este documento?'} action={remove} param={''}/>
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Requisição de Devolução">
          <Link to="/return_request">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais - {id}</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDiv">
                  <label>Cliente</label>&nbsp;<label className="required">*</label><br/>
                  <input type="text" placeholder="Cliente" value={nome_cliente} maxLength="150" disabled={true}/>
                </div>
                
                <div className="formDiv">
                  <label>Status</label>&nbsp;<label className="required">*</label><br/>
                  <select value={status} onChange={ (e) => setStatus(e.target.value) } disabled={true}>
                    <option value="">Selecione</option>
                    {listStatus.map((item, index) => (
                      <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="divGroup">                
                <div className="formDiv">
                  <label>Data</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_solicitacao" disabled />
                </div>

                <div className="formDiv">
                  <label>Hora</label><br/>
                  <input type="text" placeholder="##:##:##" value={hora_solicitacao} onChange={ (e) => setHoraSolicitacao(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true}/>
                </div>
                
                <div className="formDiv">
                  <label>Observação</label><br/>
                  <input type="text" placeholder="Observação" value={observacao} onChange={ (e) => setObservacao(e.target.value) } maxLength="200" disabled={true}/>
                </div>
              </div>
            </div>
            <br/>
            <div className="divGroup">
              <div className="formDivList">
                <div className="containerGroupData">
                  <h2>Itens&nbsp;<label className="required">*</label></h2>
                  <hr></hr>
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Status</th>
                        <th scope="col">Produto</th>
                        <th scope="col">Unidade Medida</th>
                        <th scope="col">Armazém</th>
                        <th scope="col">Quantidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((item, index)=>{
                        return(
                          <tr key={index}>
                            <td>{viewItem(listStatusItem, item.status)}</td>
                            <td>{`${item?.produto?.codigo_produto} - ${item?.produto?.descricao}`}</td>
                            <td>{item?.produto?.codigos_barra[0]?.unidade_medida?.UNIDADE}</td>
                            <td>{item.label_warehouse}</td>
                            <td>{item.quantidade}</td>
                          </tr>
                        )
                      })}
                      {rows.length === 0 && <tr>
                        <td colSpan={4}><label className='required'>Nenhum registro encontrado!</label></td>
                      </tr>}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {!view && <div className="formDiv" style={{display: "flex", gap: "0.5rem"}}>
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {['001','002','003'].indexOf(status) > -1 && <button type="button" className="buttonRemove" onClick={() => setShowModals((prevState) => ({...prevState, confirmDelete: true}))} disabled={view}>Excluir</button>}
              <button type="button" className="buttonTab" onClick={openViewOrigin}>Visualizar Origem</button>
                {['006'].indexOf(status) > -1 && <button type="button" className="buttonTab" onClick={setIntegrateErp}>Finalizar Requisição</button>}
            </div>}
          </form>
        </div>
      </div>}
      
      <Modal  
        isOpen={modalOrigin}
        onRequestClose={closeModal}
        style={customFullModal}
        contentLabel="Origem"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="divGroup">
            <div className="formDiv">
              <label>Cliente</label>&nbsp;<label className="required">*</label><br/>
              <input type="text" placeholder="Cliente" value={item_nome_cliente}  maxLength="60" disabled={true}/>
            </div>
          </div>
          <div className="divGroup">                
            <div className="formDiv">
              <label>Data</label><br/>
              <InputDate filters={infos} setFilters={setInfos} propertyFilter="item_data_solicitacao" disabled />
            </div>
  
            <div className="formDiv">
              <label>Hora</label><br/>
              <input type="text" placeholder="##:##:##" value={item_hora_solicitacao} onChange={ (e) => setHoraSolicitacao(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true}/>
            </div>
            
            <div className="formDiv">
              <label>Observacao</label><br/>
              <input type="text" placeholder="Observação" value={item_observacao} onChange={ (e) => setObservacao(e.target.value) } maxLength="200" disabled={true}/>
            </div>
          </div>
          <div className="divGroup">
            <div className="formDiv">
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th scope="col">Produto</th>
                    <th scope="col">Característica</th>
                    <th scope="col">Quantidade Solicitada</th>
                    <th scope="col">Quantidade Separada</th>
                    <th scope="col">Quantidade Devolvida</th>
                  </tr>
                </thead>
                <tbody>
                  {item_rows && item_rows.length > 0 && item_rows.map((item, index)=>{
                    return(
                      <tr key={index}>
                        <td>
                          {index+1}
                        </td>
                        <td>
                          <div className="formDiv">
                            {viewItemProduct(listProducts, item.id_produto)}
                          </div>
                        </td>
                        <td>
                          <button type="button" className="buttonTable" onClick={() => getDataFeatures(item, index)}>Ver características</button>
                        </td>
                        <td>
                          {item.quantidade}
                        </td>
                        <td>
                          {item.qtde_separada}
                        </td>
                        <td>
                          {item.qtde_devolvida}
                        </td>
                      </tr>
                  )
                })}
                {item_rows.length === 0 && 
                  <tr>
                    <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>
                }
                </tbody>
              </table>
            </div>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>
      
      <Modal  
        isOpen={modalItemFeaturesOpen}
        onRequestClose={closeModalFeatures}
        style={customShortModal}
        contentLabel="Características"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="formDiv">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Característica</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {item_feature && item_feature.length > 0 && item_feature.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td>
                        {index+1}
                      </td>
                      <td data-label="Característica">{item.descricao}</td>
                      <td data-label="Valor">{item.valor}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModalFeatures} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}